import { render, staticRenderFns } from "./impressum.vue?vue&type=template&id=a65ac9ba&"
import script from "./impressum.vue?vue&type=script&lang=js&"
export * from "./impressum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/udo/Projects/nakami/gvl/gvl-neustart/gvl-neustart-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a65ac9ba')) {
      api.createRecord('a65ac9ba', component.options)
    } else {
      api.reload('a65ac9ba', component.options)
    }
    module.hot.accept("./impressum.vue?vue&type=template&id=a65ac9ba&", function () {
      api.rerender('a65ac9ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/impressum.vue"
export default component.exports